<template>
  <div id="app">
    <vue-extend-layouts/>
  </div>
</template>

<script>
  import VueExtendLayouts from 'vue-extend-layout'

  export default {
    name: 'app',
    components: { VueExtendLayouts }
  }
</script>

<style>
  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?4817b772